const s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.927 7.41c1.903-2.273 5.889-1.588 7.147.56 1.989-3.462 7.925-1.965 7.926 3.136V18h-4.927v-6.732c0-.67-.585-1.212-1.305-1.212s-1.304.543-1.304 1.212V18H9.536v-6.732c0-.67-.584-1.212-1.304-1.212s-1.305.543-1.305 1.212V18H2V6.421h4.927z"/></svg>';
export {
  s as w
};
